export default {
  Discard: -1,
  Proposed: 0,      // Auto-generated from inspection and complaints and not saved in database
  Assigned: 1,   // It becomes a task that has to be done
  Performing: 2,   // It becomes a task that has to be done
  Reporting: 7,   // It becomes a task that has to be done
  Performed: 8,     // The fix is finished and invoice uploaded (if so)
  Finished: 9,        // Case closed
  Archived: 10,        // Case closed
}
